import * as R from 'ramda';

import { resetTerms, setTerm } from './helpers';
import { EFacilityType, NonEmptyArray, TJsonQuery } from './types';

export function setSuburbanFacilityTypes(jsonQuery: TJsonQuery) {
  return (facilityTypes: NonEmptyArray<EFacilityType> | null): TJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['bathhouse', 'garage', 'security', 'pool'])(nextJsonQuery);

    if (facilityTypes) {
      if (facilityTypes.includes(EFacilityType.Sauna)) {
        nextJsonQuery = setTerm('bathhouse')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Garage)) {
        nextJsonQuery = setTerm('garage')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Security)) {
        nextJsonQuery = setTerm('security')(nextJsonQuery)(true);
      }

      if (facilityTypes.includes(EFacilityType.Pool)) {
        nextJsonQuery = setTerm('pool')(nextJsonQuery)(true);
      }
    }

    return nextJsonQuery;
  };
}
